import * as React from 'react';

import Box from '@mui/material/Box';
import Skeleton, { SkeletonProps } from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

type ListSkeletonProps = {
  avatarVariant?: SkeletonProps['variant'];
};

export const BlockedUsersSkeleton: React.FC<ListSkeletonProps> = ({ avatarVariant }) => {
  return (
    <Stack spacing={2} sx={{ flex: '1' }}>
      {[...Array(3)].map((_, i) => (
        <Box key={i} display='flex' alignItems={'center'} justifyContent={'space-between'}>
          <Box display={'flex'} alignItems={'center'} gap={'24px'}>
            <Skeleton variant={'circular'} width={40} height={40} />
            <Skeleton variant='text' width={100} />
          </Box>
          <Skeleton variant='text' width={200} sx={{ fontSize: '0.8rem' }} />
          <Skeleton variant='rounded'  width={100} height={40} sx={{ fontSize: '0.6rem' }} />
        </Box>
      ))}
    </Stack>
  );
};
